import { Typography } from "@mui/material";
import { ContentTypography } from "../ServiceModal.styles";

export default function UnsuccessfulReporting() {
    const modalTitle = <Typography>Hier ist etwas schief gelaufen!</Typography>;
    const modalContent = (
        <ContentTypography>
            Aufgrund eines technischen Fehlers war die Meldung leider nicht
            erfolgreich. Bitte versuche es erneut.
        </ContentTypography>
    );

    return { modalTitle, modalContent, autoClosingModal: true };
}
